
<template>

    <section class="global-mentorship">
        <div class="panel">
            <div class="panel-heading">
                <h2>Meetings</h2>
            </div>

            <div class="panel-body" v-if="calendarEvents">
                <full-calendar 
                    ref="calendar" 
                    :self="self" 
                    :config="config" 
                    :header="calendarHeader" 
                    :events="calendarEvents">                        
                </full-calendar>
            </div>
        </div>
        <ta-meeting-participants
                v-if="participants"
                :participants="participants"
                :link="link"
                :recordingProcessing="recordingProcessing"
                :hasRecording="hasRecording"
                :maxParticipants="maxParticipants"
                @closeModal="participants=null"
                 />
    </section>

</template>

<script>

import TaMeetingParticipants from './widgets/TAMeetingParticipants';
import taMeetings from '../services/ta-meetings';
import moment from 'moment';

export default {
    data() {
        return {
            meetings:null,
            calendarEvents: null,
            participants: null,
            maxParticipants: null,
            link: null,
            hasRecording:null,
            recordingProcessing: null,
            config: {
                defaultView: 'month',
                droppable: false,
                displayEventTime: false,
                selectable: false,
                unselectAuto: false,
                eventDurationEditable: false,
                editable: false,                
                self:self,
                firstDay: 1,
                eventRender: function(event, element) {
                    $(element).html($(element).text())
                },
                eventClick: function(event, mouseEvent) {
                    var self = $('#calendar').fullCalendar('option', 'self');
                    let meeting = self.meetings.find((m)=> { return m.id === event.id});

                    self.participants = meeting.ta_meeting_participants;
                    self.maxParticipants = meeting.maxParticipants;

                    const now = new Date().getTime();
                    const end = new Date(meeting.endTime).getTime();

                    if (now > end && !meeting.recordingUrl) self.recordingProcessing = true;

                    if (meeting.recordingUrl) {
                        self.link = meeting.recordingUrl;
                        self.hasRecording = true;
                    } else {
                        self.link = meeting.joinUrl;
                        self.hasRecording = false;
                    }


                }
            },
            calendarHeader: {
                left:   'today prev,next',
                center: 'title',
                right:  ''
            }
        }
    },
    components: {
        TaMeetingParticipants
    },
    mounted() {
        this.config.self = this;
        this.getTAMeetings();
    },
    methods: {
        getTAMeetings() {
            taMeetings.getMine().then((response)=> {
                this.meetings = response.data.meetings;
                const meetingType = 'TA Session';
                this.calendarEvents = response.data.meetings.map((m)=> {
                    const startTime = moment.tz(m.startTime,moment.tz.guess()).format('hh:mm a');
                    const endTime = moment.tz(m.endTime,moment.tz.guess()).format('hh:mm a');


                    let meeting = {
                        id: m.id,
                        type:'meeting',
                        start: moment.tz(m.startTime,moment.tz.guess()),
                        end: moment.tz(m.endTime,moment.tz.guess()),
                        title: meetingType + '<br>' + startTime + ' - ' + endTime + '<br>' + m.ta_meeting_participants.length + ' signed up',
                        color: '#3cf',
                        textColor:'#1a1a1a',
                        type:'meeting',
                        className:'ta-meeting'
                    }


                    return meeting;
                });
            });
        }
    },
    computed: {

    }
}
</script>


<style lang="scss" scoped>

</style>

<style lang="scss">
    .fc-event-container .ta-meeting {
        cursor: pointer;
        padding:4px;
    }
    
</style>



// WEBPACK FOOTER //
// TAMeetings.vue?48951cb0